export const toTimeLineGetDuration = (str: string): string => {
  console.log(str, 'str')
  let audioTimelineOut = 0
  let videoTimelineOut = 0
  const timeline = JSON.parse(str);
  if (Array.isArray(timeline.VideoTracks)) {
    const videoTrackClips = timeline.VideoTracks[0]?.VideoTrackClips;
    videoTimelineOut = videoTrackClips[videoTrackClips.length - 1].TimelineOut
  } else {
    videoTimelineOut = 0
  }
  if (Array.isArray(timeline.AudioTracks)) {
    const audioTrackClips = timeline.AudioTracks[0]?.AudioTrackClips;
    audioTimelineOut = audioTrackClips[audioTrackClips.length - 1].TimelineOut
  } else {
    audioTimelineOut = 0
  }

  // 返回两个值中的最大值
  return formatMillisecondsToTime(
    Math.max(videoTimelineOut, audioTimelineOut) * 1000,
  );
};

export const toTimeLineGetTitle = (str: string): string => {
  const timeline = JSON.parse(str);
  return (
    timeline?.VideoTracks.filter((track) => track.Type === "Subtitle")
      .flatMap((track) => track.VideoTrackClips.map((clip) => clip.Content))
      .join(", ") || "暂无标题"
  );
};

const formatMillisecondsToTime = (milliseconds: number) => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
};
